import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, input } from '@angular/core';

import { IconModule, WithDigitGroupsPipe } from '@hglobal/fin-ui';
import { TranslateModule } from '@ngx-translate/core';

import { CopyTooltipComponent, StatusComponent } from '@kr/components';
import { RiskScoreValueComponent } from '@kr/components/risk-score-value/risk-score-value.component';
import { Transaction, WalletCard } from '@kr/models';
import { CurrencyBalanceFormatPipe } from '@kr/pipes';

@Component({
  imports: [
    IconModule,
    StatusComponent,
    CopyTooltipComponent,
    WithDigitGroupsPipe,
    RiskScoreValueComponent,
    NgClass,
    CurrencyBalanceFormatPipe,
    TranslateModule,
  ],
  selector: 'kr-mass-pay-out-item, [krMassPayOutItem]',
  templateUrl: './mass-pay-out-item.component.html',
  styleUrls: ['./mass-pay-out-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MassPayOutItemComponent {
  item = input<Transaction>();
  num = input<number>();
  wallet = input<WalletCard>();
  withStatus = input<boolean>();
  withRiskScore = input<boolean>();
  isCryptoBanco = input<boolean>();

  @HostBinding('class.kr-mass-pay-out-item_with-status') get withStatusClass(): boolean {
    return this.withStatus();
  }

  @HostBinding('class.kr-mass-pay-out-item_with-score') get withRiskScoreClass(): boolean {
    return this.withRiskScore();
  }
}
